// ----------------------------------------------------------------------------
// Snippet: Announcement Bar
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// Styles
import './_announcement-bar.scss'


// -------------------------------------
// Helper Functions
// -------------------------------------

// Check sessionStorage support and get announcementBarDismissed value
const isAnnouncementBarDismissed = () => {
    try {
        return sessionStorage.getItem('announcementBarDismissed') == getAnnouncementBarContent();
    } catch (e) {
        return false;
    }
};

// Get the plain text content of the announcement bar
const getAnnouncementBarContent = () => {
	const announcementBarContent = document.querySelector('.announcement-bar__content');
    if (!announcementBarContent) return '';
    
    return announcementBarContent.textContent.trim();
};

// Helper function to close the announcement bar
const closeAnnouncementBar = (announcementBar) => {
    announcementBar.classList.add('announcement-bar--hidden');
    announcementBar.setAttribute('aria-hidden', 'true');
    
    try {
        sessionStorage.setItem('announcementBarDismissed', getAnnouncementBarContent());
    } catch (e) {
        // sessionStorage not supported, do nothing
    }
};


// -------------------------------------
// Initialize
// -------------------------------------

// Hide the bar as early as possible
// TODO: consider moving this to a priority script loaded before the DOM to avoid CLS / flash of content
if (isAnnouncementBarDismissed()) {
    const style = document.createElement('style');
    style.innerHTML = '.announcement-bar { display: none; }';
    document.head.appendChild(style);
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
	const announcementBar      = document.querySelector('.announcement-bar');
	const announcementBarClose = document.querySelector('.announcement-bar__close');
	
    if (!announcementBar) return; // Announcement Bar disabled

	if (isAnnouncementBarDismissed()) {
		closeAnnouncementBar(announcementBar);
	}

    announcementBarClose.addEventListener('click', (event) => {
        event.preventDefault();
        closeAnnouncementBar(announcementBar);
    });

    // Enable keyboard navigation
    announcementBarClose.addEventListener('keydown', (event) => {
        // Check if the key pressed is Enter or Space
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            closeAnnouncementBar(announcementBar);
        }
    });
});
